import {
  ControllerRenderProps,
  FieldValues,
  useFormContext,
} from "react-hook-form";
import DropdownWithCheckboxes from "../Dropdown/DropdownWIthCheckboxes/DropdownWIthCheckboxes";
import { ICheckbox } from "../Checkbox/Checkbox";

export const MultiChoice = ({
  name,
  options,
  field,
  placeholder,
  hasError,
}: {
  name: string;
  options: string[];
  field: ControllerRenderProps<FieldValues, string>;
  placeholder?: string;
  hasError?: boolean;
}) => {
  const { watch } = useFormContext();
  const value = watch(name)
    ?.replaceAll(/\s*,?\s*\n/g, ", ")
    .split(", ");

  const dropdownOptions: ICheckbox[] = options.map((o, idx) => {
    return {
      id: idx,
      label: o,
      checked: value?.includes(o),
    };
  });

  return (
    <DropdownWithCheckboxes
      withFilter
      maxVisible={7}
      id={name}
      items={dropdownOptions}
      getSelectedItems={(values) => {
        field.onChange(values.map((v) => v.label).join(", "));
      }}
      placeholder={placeholder}
      hasError={hasError}
    />
  );
};
